import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HintButton } from 'components/Common/Buttons';

import questionProp from 'common/questionnaires/questionDataProp';
import { InputType } from 'common/questionnaires/types';
import QuestionButton from '../QuestionButton';
import QuestionDropdown from '../QuestionDropDown';
import QuestionFieldsInputs from '../QuestionFields';
import QuestionInformationBox from '../QuestionInformationBox';
import QuestionDatePicker from '../QuestionDatePicker';
import QuestionCheckboxField from '../QuestionCheckboxField';
import QuestionTinFields from '../QuestionTinFields';
import QuestionDateDropdown from '../QuestionDateDropdown';
import QuestionGiinField from '../QuestionGiinField';

const Question = ({ isForm, question, question: { id, name, inputs, questionText, questionTextIsHtml, hasError = false, errorMessage, answer, dynamicUpdate }, emdedded, customerName, derivedName }) => {
  const formattedMessageNameValues = { CustomerName: customerName, DerivedName: (derivedName !== '') ? derivedName : customerName };
  const [showInstructions, setShowInstructions] = useState(false);

  const viewInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  return (
    <div className={ `question ${ emdedded ? 'embedded' : '' }` }>
      <span className="d-block">
        {questionText && (questionTextIsHtml
          ? <span className="question-title d-inline-block mt-2 mb-1"><FormattedHTMLMessage id={ questionText } values={ formattedMessageNameValues } />
            { questionText && question.info && <HintButton className="float-right" active={ showInstructions } hintType="hint" onClick={ () => viewInstructions() } /> }
          </span>
          : <span className="question-title d-inline-block mt-2 mb-1"><FormattedMessage id={ questionText } values={ formattedMessageNameValues } />
            { questionText && question.info && <HintButton className="float-right" active={ showInstructions } hintType="hint" onClick={ () => viewInstructions() } /> }
          </span>) }
      </span>
      { showInstructions && <div className="info mt-1"><span>{ question.info }</span></div>}
      <React.Fragment>
        {inputs && ((inputs.type === InputType.Dropdown && inputs.items && inputs.items.length) || inputs.type === InputType.CountryDropdown)
          && <QuestionDropdown id={ id } name={ name } isForm={ isForm } inputs={ inputs } answer={ answer } dynamicUpdate={ dynamicUpdate } />}
        {inputs && (inputs.type === InputType.Select || inputs.type === InputType.YesNo) && inputs.buttonTitles
          && <QuestionButton id={ id } name={ name } titles={ inputs.buttonTitles } isForm={ isForm } buttonCount={ inputs.buttonTitles.length } question={ question } /> }
        {inputs && inputs.type === InputType.TextFields && <QuestionFieldsInputs id={ id } name={ name } dynamicUpdate={ dynamicUpdate } isForm={ isForm } fields={ inputs.fields } hasError={ hasError } answer={ answer } /> }
        {inputs && inputs.type === InputType.NumericField
        && <QuestionFieldsInputs id={ id } name={ name } dynamicUpdate={ dynamicUpdate } isForm={ isForm } fields={ inputs.fields } hasError={ hasError } maxValue={ inputs.maxValue } isNumericOnly /> }
        {inputs && inputs.type === InputType.DatePicker
        && <QuestionDatePicker id={ id } name={ name } isForm={ isForm } dateFormat={ inputs.dateFormat } maxDate={ inputs.maxDate } defaultDate={ inputs.defaultDate } placeholder={ inputs.fields[0].placeholder } />}
        { inputs && inputs.type === InputType.DateDropdown && <QuestionDateDropdown id={ id } name={ name } isForm={ isForm } dateFormat={ inputs.dateFormat } maxDate={ inputs.maxDate } minDate={ inputs.minDate } /> }
        {inputs && inputs.type === InputType.Checkbox && <QuestionCheckboxField id={ id } name={ name } isForm={ isForm } answer={ answer } /> }
        {inputs && inputs.type === InputType.TinField && <QuestionTinFields id={ id } name={ name } isForm={ isForm } dynamicUpdate={ dynamicUpdate } fields={ inputs.fields } /> }
        {inputs && inputs.type === InputType.GiinField && <QuestionGiinField id={ id } name={ name } isForm={ isForm } dynamicUpdate={ dynamicUpdate } fields={ inputs.fields } /> }
      </React.Fragment>
      {(question && (question.informationBoxReference || question.informationBoxComplexReferences))
        && <QuestionInformationBox reference={ question.informationBoxReference } complexReferences={ question.informationBoxComplexReferences } />}
      {hasError && errorMessage && <div className="error-container">
        <FontAwesomeIcon icon="times" className="i-cross" /><p>{errorMessage}</p> </div>}
    </div>
  );
};

Question.propTypes = {
  question: questionProp.isRequired,
  isForm: PropTypes.bool,
  emdedded: PropTypes.bool.isRequired,
  customerName: PropTypes.string,
  derivedName: PropTypes.string
};

Question.defaultProps = {
  isForm: false,
  customerName: '',
  derivedName: ''
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
    preQualifyingQuestionnaire: { derivedName }
  } = state;

  return {
    customerName: onlineConfig && onlineConfig.customerName,
    derivedName
  };
}

export default connect(mapStateToProps)(Question);
